// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"bc0199cb","55":"bc0199cb","347":"77db1091","613":"bc0199cb","674":"31d6cfe0","807":"bc0199cb"}[chunkId] + ".chunk.css";
};